import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';

// (임시 CSS - 나중에 별도 파일로 분리하세요)
const pageStyles = {
  container: { maxWidth: '600px' },
  formGroup: { marginBottom: '15px' },
  label: { display: 'block', marginBottom: '5px', fontWeight: 'bold' },
  input: { width: '100%', padding: '8px', boxSizing: 'border-box' },
  button: { padding: '10px 15px', cursor: 'pointer', backgroundColor: '#007bff', color: 'white', border: 'none' },
  message: { marginTop: '15px' },
  sectionTitle: { marginTop: '30px', marginBottom: '12px', fontSize: '1.1rem', fontWeight: 'bold', paddingBottom: '8px', borderBottom: '2px solid #dee2e6' },
  checkboxRow: { display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px', cursor: 'pointer' },
};

const PersonalSettingsPage = () => {
  const { user } = useAuth(); // 현재 로그인한 사용자 정보
  
  const [name, setName] = useState(user?.name || ''); // 현재 이름으로 초기화
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  // 알림 수신 설정
  const [leaveApproved, setLeaveApproved] = useState(true);
  const [leaveRejected, setLeaveRejected] = useState(true);
  const [leaveCancelled, setLeaveCancelled] = useState(true);
  const [notifPrefsLoading, setNotifPrefsLoading] = useState(true);
  const [notifPrefsSaving, setNotifPrefsSaving] = useState(false);
  const [notifPrefsMessage, setNotifPrefsMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (password !== confirmPassword) {
      setError('새 비밀번호가 일치하지 않습니다.');
      return;
    }

    try {
      const payload = { name };
      if (password) {
        payload.password = password; // 비밀번호를 입력한 경우에만 포함
      }

      // [PUT] /api/users/profile 호출
      const res = await api.put('/users/profile', payload);
      
      setMessage('개인정보가 성공적으로 수정되었습니다.');
      // (선택) AuthContext의 user 정보도 업데이트하면 좋음
      // auth.updateUser(res.data.user); 
      setPassword('');
      setConfirmPassword('');

    } catch (err) {
      setError(err.response?.data?.message || '수정 중 오류가 발생했습니다.');
    }
  };

  // 알림 설정 로드
  useEffect(() => {
    const fetchNotifPrefs = async () => {
      try {
        const res = await api.get('/users/notification-preferences');
        setLeaveApproved(res.data?.leaveApproved !== false);
        setLeaveRejected(res.data?.leaveRejected !== false);
        setLeaveCancelled(res.data?.leaveCancelled !== false);
      } catch (err) {
        // 기본값 유지
      } finally {
        setNotifPrefsLoading(false);
      }
    };
    fetchNotifPrefs();
  }, []);

  const handleSaveNotificationPrefs = async () => {
    setNotifPrefsMessage('');
    setNotifPrefsSaving(true);
    try {
      const res = await api.put('/users/notification-preferences', {
        leaveApproved: Boolean(leaveApproved),
        leaveRejected: Boolean(leaveRejected),
        leaveCancelled: Boolean(leaveCancelled),
      });
      setNotifPrefsMessage('알림 설정이 저장되었습니다.');
      // 저장된 값으로 상태 동기화
      if (res.data) {
        setLeaveApproved(res.data.leaveApproved !== false);
        setLeaveRejected(res.data.leaveRejected !== false);
        setLeaveCancelled(res.data.leaveCancelled !== false);
      }
    } catch (err) {
      setNotifPrefsMessage(err.response?.data?.message || '저장에 실패했습니다.');
    } finally {
      setNotifPrefsSaving(false);
    }
  };

  return (
    <div style={pageStyles.container}>
      <h2>개인 설정</h2>
      <form onSubmit={handleSubmit}>
        <div style={pageStyles.formGroup}>
          <label style={pageStyles.label}>아이디</label>
          <input 
            type="text" 
            style={pageStyles.input}
            value={user?.userId || ''} 
            disabled // 아이디는 수정 불가
          />
        </div>
        <div style={pageStyles.formGroup}>
          <label htmlFor="name" style={pageStyles.label}>성명</label>
          <input
            id="name"
            type="text"
            style={pageStyles.input}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div style={pageStyles.formGroup}>
          <label htmlFor="password" style={pageStyles.label}>새 비밀번호 (변경 시에만 입력)</label>
          <input
            id="password"
            type="password"
            style={pageStyles.input}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div style={pageStyles.formGroup}>
          <label htmlFor="confirmPassword" style={pageStyles.label}>새 비밀번호 확인</label>
          <input
            id="confirmPassword"
            type="password"
            style={pageStyles.input}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>
        
        <button type="submit" style={pageStyles.button}>수정하기</button>
        
        {message && <p style={{...pageStyles.message, color: 'green'}}>{message}</p>}
        {error && <p style={{...pageStyles.message, color: 'red'}}>{error}</p>}
      </form>

      <h3 style={pageStyles.sectionTitle}>알림 수신 설정</h3>
      <p style={{ fontSize: '0.9rem', color: '#666', marginBottom: '16px' }}>
        등록한 참여자의 연차 신청 결과에 대해 알림을 받을 조건을 선택하세요.
      </p>
      {!notifPrefsLoading && (
        <>
          <label style={pageStyles.checkboxRow}>
            <input type="checkbox" checked={leaveApproved} onChange={(e) => setLeaveApproved(e.target.checked)} />
            <span>연차 승인 시 알림</span>
          </label>
          <label style={pageStyles.checkboxRow}>
            <input type="checkbox" checked={leaveRejected} onChange={(e) => setLeaveRejected(e.target.checked)} />
            <span>연차 반려 시 알림</span>
          </label>
          <label style={pageStyles.checkboxRow}>
            <input type="checkbox" checked={leaveCancelled} onChange={(e) => setLeaveCancelled(e.target.checked)} />
            <span>연차 취소 시 알림</span>
          </label>
          <button type="button" style={pageStyles.button} onClick={handleSaveNotificationPrefs} disabled={notifPrefsSaving}>
            {notifPrefsSaving ? '저장 중...' : '알림 설정 저장'}
          </button>
          {notifPrefsMessage && <p style={{...pageStyles.message, color: notifPrefsMessage.includes('실패') ? 'red' : 'green'}}>{notifPrefsMessage}</p>}
        </>
      )}
    </div>
  );
};

export default PersonalSettingsPage;